import { Provider, Injector } from '@angular/core';
import { TOKEN_SERVICE } from '../tokens/token-service.token';
import { ITokenService } from '@app/models/objects/token-service.model';
import { MobileTokenService } from '../services/mobile-token.service';
import { TokenService } from '../services/token.service';
import { isFromMobileApp } from '../helpers';

export function tokenServiceFactory(injector: Injector): ITokenService {
  return isFromMobileApp()
    ? injector.get(MobileTokenService)
    : injector.get(TokenService);
}

export const TOKEN_SERVICE_PROVIDER: Provider = {
  provide: TOKEN_SERVICE,
  useFactory: tokenServiceFactory,
  deps: [Injector],
};
